import { tv } from '~/utils/tv'

export const InputMultiSelectHelperTextVariants = tv({
  base: 'flex w-full flex-wrap items-center justify-start gap-onepulse px-onepulse text-left font-rdmodern font-semibold text-text-neutral-alternative text-threepulse',
  variants: {
    hasError: {
      true: 'text-text-danger-alternative',
      false: '',
    },
    readOnly: {
      true: 'cursor-not-allowed text-text-neutral-readonly',
    },
    disabled: {
      true: 'cursor-not-allowed text-text-neutral-disabled',
      false: '',
    },
  },
  compoundVariants: [
    {
      readOnly: true,
      disabled: false,
      class: 'text-text-neutral-readonly',
    },
  ],
  defaultVariants: {
    error: false,
    disabled: false,
    readOnly: false,
  },
})
